import { render } from "./EmployeeDetailsListItem.vue?vue&type=template&id=d6dbb28e"
import script from "./EmployeeDetailsListItem.vue?vue&type=script&lang=ts"
export * from "./EmployeeDetailsListItem.vue?vue&type=script&lang=ts"
script.render = render

export default script